import { ReactNode } from "react";
import { Nullable } from "../../../types/utils";
import { OrderCostingVersion, TApiOrderDetails, TOrderCost } from "../../api/endpoints/Order";
import HelpTexts from "../../components/HelpTexts";

const isExpired = (order: TApiOrderDetails) => {
  return order.expired_at !== null;
};

const currentOrderVersion = (
  order: TApiOrderDetails,
  costingVersions: Array<OrderCostingVersion>
): OrderCostingVersion | undefined => {
  return costingVersions.find(
    costingVersion => costingVersion.version === order.cost.version
  );
}

const isOverVolumeLimit = (cost: TOrderCost, costingVersion?: Nullable<OrderCostingVersion>) => {
  const { average_daily_volume } = cost.data.total_cost ?? {};

  if (!average_daily_volume || !costingVersion) {
    return false;
  }

  return average_daily_volume > costingVersion.max_average_daily_volume;
}

const RESEARCH_LICENCE_LABEL_BY_VERSION_MAPPING: Record<
  TApiOrderDetails['cost']['version'],
  { title: string, info: ReactNode }
> = Object.freeze({
  v1: {
    title: "Requested research licence",
    info: HelpTexts.researchLicenceInfo()
  },
  v2: {
    title: "Requested research licence",
    info: HelpTexts.researchLicenceInfo()
  },
  v3: {
    title: "Requested research licence",
    info: HelpTexts.researchLicenceInfo()
  },
  v4: {
    title: "Requested research licence",
    info: HelpTexts.researchLicenceInfo()
  },
  v5: {
    title: "Requested research licence",
    info: HelpTexts.researchLicenceInfo()
  },
  v6: {
    title: "Research Project Fee-Waiver Service Agreement",
    info: HelpTexts.researchProjectFeeWaiverInfo()
  }
});

const OrderHelpers = {
  isOverVolumeLimit,
  isExpired,
  currentOrderVersion,
  RESEARCH_LICENCE_LABEL_BY_VERSION_MAPPING
}

export default OrderHelpers;
